import React, { memo, useEffect, useState, useRef } from "react";
import "../css/loader.css";

const Loader = memo(({ fading }) => {
  const [text, setText] = useState("");
  const fullText = "Crafting your resume...";
  const frameRef = useRef(null);
  const indexRef = useRef(0);

  // Optimized typewriter with requestAnimationFrame
  useEffect(() => {
    let startTime = performance.now();
    let lastUpdate = 0;
    const interval = 80; // ms per character

    const updateText = (timestamp) => {
      if (!frameRef.current) return;

      if (timestamp - lastUpdate >= interval) {
        const i = indexRef.current;
        if (i < fullText.length) {
          setText(fullText.slice(0, i + 1));
          indexRef.current = i + 1;
          lastUpdate = timestamp;
          frameRef.current = requestAnimationFrame(updateText);
        } else {
          frameRef.current = null;
        }
      } else {
        frameRef.current = requestAnimationFrame(updateText);
      }
    };

    frameRef.current = requestAnimationFrame(updateText);
    return () => {
      if (frameRef.current) {
        cancelAnimationFrame(frameRef.current);
        frameRef.current = null;
      }
    };
  }, []);

  return (
    <div className={`resume-loader ${fading ? "fade-out" : ""}`}>
      {/* Animated background gradient */}
      <div className="loader-bg" />

      {/* Text Logo - ResumeEra.xyz */}
      <div className="loader-logo-wrapper" style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "10px"
      }}>
        <p className="loader-logo-text" style={{
          fontFamily: "'Poppins', 'Segoe UI', sans-serif",
          fontSize: "clamp(2rem, 5vw, 3.2rem)",
          fontWeight: "700",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          letterSpacing: "2px",
          margin: 0,
          padding: "0",
          textShadow: "0 0 40px rgba(118, 75, 162, 0.15)"
        }}>
          ResumeEra<span style={{
            color: "#764ba2",
            WebkitTextFillColor: "#764ba2",
            fontSize: "clamp(1.2rem, 3vw, 2rem)",
            fontWeight: "300",
            opacity: "0.85"
          }}>.xyz</span>
        </p>
      </div>

      {/* Typewriter Text */}
      <p className="loader-text">{text}</p>

      {/* Animated progress bar */}
      <div className="progress-track">
        <div className="progress-bar" />
      </div>
    </div>
  );
});

Loader.displayName = "Loader";
export default Loader;